// BFF: ○ gap — legacy macro / macrosMe endpoints. Macros have no bff/crm module.
export {
  MacrosProvider,
  useMacros,
  useCreateMacro,
  useUpdateMacro,
  useDeleteMacro,
} from './MacrosProvider'
export type { TextMacro } from './MacrosProvider'
